module.exports = __webpack_public_path__ + "static/only_office-33a8ed7e27d118381972c2d9006fd662.png";